// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__ZGZRd","itemTitle":"ClientEmergencyInfo_itemTitle__1DtAm","itemText":"ClientEmergencyInfo_itemText__1yoLX"};